module.exports = __webpack_public_path__ + "static/idas-sm-cc7b4741aa06b43c9f3072c1d3e1c527.jpg";